<header class="wishlist-overview-hero">
  <div class="hero-appbar">
    <div>
      <h1>{{ view().title }}</h1>
      <p>{{ view().subtitle }}</p>
    </div>

    <div class="hero-actions">
      <ui-icon-button
        ariaLabel="Szukaj"
        variant="soft"
        (pressed)="handleSearchSelected()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="m16 16 4 4" />
        </svg>
      </ui-icon-button>
      <ui-icon-button
        ariaLabel="Nowa wishlista"
        variant="solid"
        (pressed)="handleCreateSelected()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          aria-hidden="true"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
      </ui-icon-button>
    </div>
  </div>

  <div class="hero-magazine">
    <p><span aria-hidden="true">✦</span> Magazyn</p>
    <strong>{{ view().statement }}</strong>
  </div>
</header>
